import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}deheilige/`;

const title = "Holy Road - De Heilige";
const description = "Het graf van de oermoeder Rachel ligt in Bethlehem, maar je kunt er alleen vanuit Israël naartoe. Is dit bijbels hartland, of de essentie van koloniale logica?";
const featuredImage = `${imageFolder}deheilige/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}deheilige`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Paragraph",
        text: "Rachel en Jacob waren verliefd op elkaar. Ze trouwden nadat Jacob veertien jaar had moeten werken voor zijn oom - haar vader. Ze kregen twee kinderen. Rachel stierf in het kraambed toen ze beviel van haar tweede zoon, Benjamin. Ze werd begraven in een eenvoudige tombe vlakbij Bethlehem. Eeuwenlang werd de tombe beheerd door moslims en was het een bedevaartsoord voor christenen, joden en moslims. Route 60 loopt langs heiligdommen en onheilsplekken. Een van die heiligdommen is het Graf van Rachel, al sinds de vierde eeuw na Christus een pelgrimsoord voor joden, christenen en moslims."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}30__mobile.jpg`,
            tablet: `${imageFolder}30.jpg`,
            desktop: `${imageFolder}30.jpg`,
            alt: "",
            text: "Graf van Rachel gefotografeerd tussen 1898 en 1946 door een fotograaf van de American Colony"
        }
    },
    {
        type: "Paragraph",
        text: "Een stoet kamelen trekt voorbij aan een stenen gebouwtje, tegen de achtergrond van de ongerepte heuvels van Judea. Op deze foto uit 1898 staat de graftombe van oermoeder Rachel, belangrijk voor alle monotheïstische religies, in een omgeving die millennialang onveranderd is gebleven: het bijbelse hartland tussen Jeruzalem en Bethlehem. Alleen het gebouwtje zelf is in de loop der eeuwen wat uitgebreid. Het monument is verbeeld in talloze schilderijen en bezongen in gedichten, zoals in Nicholas Michells gedicht Rachel’s Tomb. Het beeld dat oprijst uit deze culturele uitingen, vooral van Joodse zijde, is dat van een geromantiseerd verlangen."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow1/01__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/01.jpg`,
                desktop: `${imageFolder}slideshow1/01.jpg`,
                alt: "",
                text: "Het graf van Rachel geschilderd door de Britse kunstenaar Samuel Lawson Booth in 1900"
            },
            {
                mobile: `${imageFolder}slideshow1/02__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/02.jpg`,
                desktop: `${imageFolder}slideshow1/02.jpg`,
                alt: "",
                text: "Rachels tombe gefotografeerd door een fotograaf van de American Colony tussen 1898 en 1914"
            },
            {
                mobile: `${imageFolder}slideshow1/03__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/03.jpg`,
                desktop: `${imageFolder}slideshow1/03.jpg`,
                alt: "",
                text: "Postzegels waar het graf van Rachel op staat gebruikt in Palestina onder Brits mandaat tussen 1927 en 1942"
            },
            {
                mobile: `${imageFolder}slideshow1/04__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/04.jpg`,
                desktop: `${imageFolder}slideshow1/04.jpg`,
                alt: "",
                text: "Het graf van Rachel in de jaren 30"
            },
            {
                mobile: `${imageFolder}slideshow1/05__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/05.jpg`,
                desktop: `${imageFolder}slideshow1/05.jpg`,
                alt: "",
                text: "Een oude kleurenfoto van graf van Rachel. Foto: Matson Photoservice, jaartal onbekend."
            },
            {
                mobile: `${imageFolder}slideshow1/06__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/06.jpg`,
                desktop: `${imageFolder}slideshow1/06.jpg`,
                alt: "",
                text: "Een fotograaf van de American Colony fotografeert Britse militairen van een Schots regiment die passanten controleren op route 60 voor Rachels graf in de jaren 40"
            },
            {
                mobile: `${imageFolder}slideshow1/07__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/07.jpg`,
                desktop: `${imageFolder}slideshow1/07.jpg`,
                alt: "",
                text: "Een halve Palestijnse pond met een afbeelding van Rachels graf. Deze munteenheid, in 1927 geïntroduceerd door de Britten werd tot 1950 in de Westelijke Jordaanoever gebruikt."
            },
            {
                mobile: `${imageFolder}slideshow1/08__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/08.jpg`,
                desktop: `${imageFolder}slideshow1/08.jpg`,
                alt: "",
                text: "Joodse vrouwen voor het graf van Rachel in 1967. Foto: Yosef Tamir"
            },
            {
                mobile: `${imageFolder}slideshow1/09__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/09.jpg`,
                desktop: `${imageFolder}slideshow1/09.jpg`,
                alt: "",
                text: "Het graf van Rachel in 1978"
            },
            {
                mobile: `${imageFolder}slideshow1/26__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/26.jpg`,
                desktop: `${imageFolder}slideshow1/26.jpg`,
                alt: "",
                text: "De tegenwoordige ingang van het Graf van Rachel"
            }
        ],
    },
    {
        type: "Paragraph",
        text: "Tot diep in de negentiende eeuw waren er weinig Joden in dit gebied, destijds deel van het Ottomaanse Rijk, en het was slechts weinigen gegeven om ernaartoe te reizen. De grote Joodse immigratiegolven naar Palestina van eind negentiende en begin twintigste eeuw maakten het Graf van Rachel toegankelijk voor grote groepen joodse gelovigen. Tijdens de Arabisch-Israëlische oorlog van 1948 viel het monument toe aan Jordanië. Negentien jaar lang konden Joden het niet bezoeken, wat het verlangen weer verhevigde. Deze begeerte werd ingelost in 1967, toen de Israëlische bezetting van de Westelijke Jordaanoever begon."
    },
    {
        type: "Paragraph",
        text: "En nu ziet het Graf van Rachel er zo uit:"
    },
    {
        type: "Iframe",
        url: "https://player.vimeo.com/video/214016315",
        text: "Aankomst bij Rachels Tombe vanaf Route 60."
    },
    {
        type: "Paragraph",
        text: "Wie de Israëlische bezetting van de Westelijke Jordaanoever wil begrijpen, moet kijken naar het Graf van Rachel. Religieuze belangen, militaire macht en esthetische misvorming zijn hier samengebald op luttele vierkante meters. De fortificatie van deze heilige plek vormt, volgens sommigen, de essentie van koloniale logica. Nog altijd bezoeken gelovigen het graf. Maar de religieuze ervaring heeft onmiskenbaar een machtspolitieke factor gekregen. Joden bezitten nu het exclusieve gebruiksrecht op deze heilige plaats; het Graf van Rachel, dat midden in het Palestijnse Bethlehem ligt, is een synagoge geworden. Een metershoge muur met militaire wachtposten moet deze exclusiviteit garanderen."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}28__mobile.jpg`,
            tablet: `${imageFolder}28.jpg`,
            desktop: `${imageFolder}28.jpg`,
            alt: "",
            text: "Naast Rachels graf binnen de muur is het leger altijd aanwezig. De blauwe poort wordt gebruikt door het leger als uitvalsbasis naar Aida vluchtelingenkamp."
        }
    },
    {
        type: "Paragraph",
        text: "Na de Zesdaagse oorlog in 1967 kwam de tombe in beheer van het Israëlische rabbinaat. Vanuit rechts-nationalistische en ultra-orthodoxe hoek kwam fel verzet toen de tombe tijdens de Oslo-akkoorden eind jaren negentig werd toegewezen aan de Palestijnse Autoriteit."
    },
    {
        type: "Paragraph",
        text: "Daarom besloot Israël de grenzen iets te verleggen, precies om het monument heen. Zo kwam een heilige plaats midden in een Palestijnse stad toch onder Israëlisch gezag te staan. Er werd een Joodse nederzetting gesticht en in 2001 werd de tombe opnieuw geannexeerd door Israël. Rond de tombe verscheen een acht meter hoge muur die oude weg van Hebron via Bethlehem naar Jeruzalem blokkeert. Voor Palestijnen is het onmogelijk om deze bedevaartsplek te zien. Rachels graf is alleen nog toegankelijk voor Joodse bedevaarders en toeristen."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}01__mobile.jpg`,
            tablet: `${imageFolder}01.jpg`,
            desktop: `${imageFolder}01.jpg`,
            alt: "",
            text: "Een overzicht van de muur rond Rachels graf, gezien vanuit Bethlehem."
        }
    },
    {
        type: "Paragraph",
        text: "De muur loopt niet op de Groene Lijn, de grens tussen Israël en de Westelijke Jordaanoever, maar is voor het grootste deel kilometers diep in Palestijns gebied gebouwd. De route van de muur volgt de uitstulping van de grens rond het Graf van Rachel. Van bovenaf gezien steekt het Israëlische grondgebied hier als een arm met een gebalde vuist de stad Bethlehem in. Vanuit Bethlehem is het graf niet meer te bereiken. Eeuwenlang zijn Jeruzalem en Bethlehem twin cities geweest, als Boeda en Pest, als Hoogezand en Sappemeer. In Bethlehem werd Jezus geboren, in Jeruzalem stierf hij. Pas in 2004 zijn de chirurgen van de Israëlische regering erin geslaagd deze Siamese tweeling van elkaar te scheiden."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}27__mobile.jpg`,
            tablet: `${imageFolder}27.jpg`,
            desktop: `${imageFolder}27.jpg`,
            alt: "",
            text: "Rondom het Graf van Rachel (bij de Davidsster) doet zich een ingewikkelde grenssituatie voor. Het hele gebied op dit kaartje behoort tot de door Israël bezette Westelijke Jordaanoever. Boven de dikke paarse streep ligt Oost-Jeruzalem, eronder Bethlehem. De groene lijn is de grens tussen het door Israël gecontroleerde Area C (boven) en het Palestijnse Area A (onder). En dan is er nog de rode lijn: de afscheidingsmuur die zich om het grafmonument heen slingert."
        }
    },
    {
        type: "Paragraph",
        text: "De muur moet garanderen dat gelovige joden vanuit Jeruzalem ongelimiteerd het graf van de oermoeder kunnen bereiken. Vanuit Beitar Illit, een ultraorthodoxe nederzetting op de Westelijke Jordaanoever, gaat er zelfs een speciale buslijn naar deze heilige plek. Het is dan ook druk bezocht. Het grafmonument, een gebouw uit het Ottomaanse tijdperk, kent gescheiden ingangen voor mannen en vrouwen. Beide seksen komen uiteindelijk uit aan weerszijden van dezelfde rustplaats: een betonnen structuur, met dik plastic beschermd tegen de handpalmen, voorhoofden en lippen van biddende orthodoxe joden."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow2/15__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/15.jpg`,
                desktop: `${imageFolder}slideshow2/15.jpg`,
                alt: "",
                text: "Biddende mannen bij de tombe van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/16__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/16.jpg`,
                desktop: `${imageFolder}slideshow2/16.jpg`,
                alt: "",
                text: "Een Orthodoxe Jood staat te bidden bij de tombe van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/17__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/17.jpg`,
                desktop: `${imageFolder}slideshow2/17.jpg`,
                alt: "",
                text: "Een speciale Thora rol bij de mannen ingang van het graf van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/18__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/18.jpg`,
                desktop: `${imageFolder}slideshow2/18.jpg`,
                alt: "",
                text: "Orthodoxe Joden in het mannendeel van het graf van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/19__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/19.jpg`,
                desktop: `${imageFolder}slideshow2/19.jpg`,
                alt: "",
                text: "Joodse mannen bidden en studeren de Thora bij het graf van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/20__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/20.jpg`,
                desktop: `${imageFolder}slideshow2/20.jpg`,
                alt: "",
                text: "Biddende vrouwen bij de tombe van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/21__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/21.jpg`,
                desktop: `${imageFolder}slideshow2/21.jpg`,
                alt: "",
                text: "Vrouwen kussen de graftombe van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/22__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/22.jpg`,
                desktop: `${imageFolder}slideshow2/22.jpg`,
                alt: "",
                text: "Een Joodse vrouw bid bij de graftombe van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/23__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/23.jpg`,
                desktop: `${imageFolder}slideshow2/23.jpg`,
                alt: "",
                text: "Een Joodse vrouw met gebedenboek bij de tombe van Rachel"
            },
            {
                mobile: `${imageFolder}slideshow2/24__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/24.jpg`,
                desktop: `${imageFolder}slideshow2/24.jpg`,
                alt: "",
                text: "Biddende vrouwen bij de tombe van Rachel met op de achtergrond het gordijn dat gemaakt is van de trouwjurk van Nava Applebaum, een Amerikaans-Israëlische vrouw van twintig die op 9 september 2003, één dag voor haar bruiloft, omkwam bij een zelfmoordaanslag in West-Jeruzalem."
            },
            {
                mobile: `${imageFolder}slideshow2/25__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/25.jpg`,
                desktop: `${imageFolder}slideshow2/25.jpg`,
                alt: "",
                text: "De manneningang van het graf van Rachel waar vroeger route 60 liep."
            }
        ]
    },
    {
        type: "Paragraph",
        text: "Rachels graf geldt als een symbool van de terugkeer van de Joden naar Zion, hun oude thuisland. Joodse vrouwen bidden er voor vruchtbaarheid en een geslaagde geboorte, een verwijzing naar het leven van Rachel, die lang geen kinderen kon krijgen maar wier gebeden uiteindelijk verhoord werden. Een opvallend relikwie is het gordijn dat gedrapeerd is over de Thora-ark, de kast waarin de vijf Thorarollen bewaard worden. Dit gordijn is gemaakt van de trouwjurk van Nava Applebaum, een Amerikaans-Israëlische vrouw van twintig die op 9 september 2003, één dag voor haar bruiloft, omkwam bij een zelfmoordaanslag in West-Jeruzalem."
    },
    {
        type: "Paragraph",
        text: "Opmerkelijk genoeg verwijzen de joodse gelovigen naar de bijbelse matriarch alsof ze hun eigen moeder is. Zo zegt de twintigjarige Joodse toeriste Shiffy Klein uit New York, die Rachels graf bezoekt op haar huwelijksreis: ‘Bij je moeder kun je eerlijk zijn, jezelf zijn, je hart laten spreken.’ Dat is ook de reden dat Klein deze tombe prefereert boven de acht kilometer noordelijker gelegen Klaagmuur, zegt ze. ‘Er zijn zo veel mensen daar. Het voelt niet zo intiem als hier.’"
    },
    {
        type: "Paragraph",
        text: "Geheel volgens de traditie heeft ook Klein voor vruchtbaarheid gebeden. ‘Ik zei tegen Rachel: help me alstublieft om ook een moeder te worden.’ Dat het monument door muren is omgeven, vindt Klein geen probleem. ‘We bidden ook voor een tijd waarin muren niet nodig zijn. Maar als je binnen bent, als je bij haar bent, voel je je veilig.’"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}14__mobile.jpg`,
            tablet: `${imageFolder}14.jpg`,
            desktop: `${imageFolder}14.jpg`,
            alt: "",
            text: "Binnen de muur vlakbij het graf van Rachel is een muurschildering van het graf aangebracht met een bijbeltekst van Genesis 35 vers 16 -20 waarin de dood van Rachel en haar begrafenis wordt beschreven."
        }
    },
    {
        type: "Paragraph",
        text: "De veiligheid van de orthodoxe joden in de tombe heeft een prijs - voor de Palestijnen aan de andere kant. Er is een checkpoint tussen Jeruzalem en Bethlehem. Sommige Palestijnen mogen hier doorheen, bijvoorbeeld wie een Israëlische ID-kaart heeft, of wie een vergunning heeft om aan de Israëlische kant te werken. Voor veel andere Palestijnen is de muur de feitelijke grens. Bij het graf van de oermoeder begint voor hen de andere kant, Israël – ook al is er geen land ter wereld dat dit bezette gebied tot Israël rekent."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow3/02__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/02.jpg`,
                desktop: `${imageFolder}slideshow3/02.jpg`,
                alt: "",
                text: "Overal waar je in dit deel van Bethlehem loopt zie je de muur rond het graf van Rachel boven de huizen uitkomen"
            },
            {
                mobile: `${imageFolder}slideshow3/03__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/03.jpg`,
                desktop: `${imageFolder}slideshow3/03.jpg`,
                alt: "",
                text: "Achter de muur loopt de weg die naar het graf van Rachel leidt."
            },
            {
                mobile: `${imageFolder}slideshow3/04__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/04.jpg`,
                desktop: `${imageFolder}slideshow3/04.jpg`,
                alt: "",
                text: "Aan de andere kant van de muur kun je de ingang van het graf van Rachel zien."
            },
            {
                mobile: `${imageFolder}slideshow3/05__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/05.jpg`,
                desktop: `${imageFolder}slideshow3/05.jpg`,
                alt: "",
                text: "Door de blauwe poort komt het leger met zekere regelmaat om een inval te doen in het Aida vluchtelingenkamp."
            },
            {
                mobile: `${imageFolder}slideshow3/06__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/06.jpg`,
                desktop: `${imageFolder}slideshow3/06.jpg`,
                alt: "",
                text: "In het midden van de foto is de koepel van het graf van Rachel te zien, gefotografeerd vanaf de begraafplaats tussen Rachels graf en Aida vluchtelingenkamp"
            },
            {
                mobile: `${imageFolder}slideshow3/07__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/07.jpg`,
                desktop: `${imageFolder}slideshow3/07.jpg`,
                alt: "",
                text: "Het graf van Rachel, door het hoge hek kun je net niet meer de koepel zien."
            },
            {
                mobile: `${imageFolder}slideshow3/08__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/08.jpg`,
                desktop: `${imageFolder}slideshow3/08.jpg`,
                alt: "",
                text: "Hier achter de muur, naast het graf van Rachel  wonen Joodse kolonisten."
            },
            {
                mobile: `${imageFolder}slideshow3/09__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/09.jpg`,
                desktop: `${imageFolder}slideshow3/09.jpg`,
                alt: "",
                text: "De speeltuin van Wi’am"
            },
            {
                mobile: `${imageFolder}slideshow3/10__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/10.jpg`,
                desktop: `${imageFolder}slideshow3/10.jpg`,
                alt: "",
                text: "De muur over het land van Wi’am waardoor Nicola een kwart van zijn land kwijt raakte."
            },
            {
                mobile: `${imageFolder}slideshow3/11__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/11.jpg`,
                desktop: `${imageFolder}slideshow3/11.jpg`,
                alt: "",
                text: "Als je hier door de poort zou gaan zit je op de oude route 60 die langs het graf van Rachel loopt."
            },
            {
                mobile: `${imageFolder}slideshow3/12__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/12.jpg`,
                desktop: `${imageFolder}slideshow3/12.jpg`,
                alt: "",
                text: "Voordat de muur bestond was dit benzinestation, recht tegenover het graf van Rachel één van de drukste stations van Bethlehem."
            },
            {
                mobile: `${imageFolder}slideshow3/13__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/13.jpg`,
                desktop: `${imageFolder}slideshow3/13.jpg`,
                alt: "",
                text: "De muur in de richting van checkpoint 300 waar Palestijnen van de Westelijke Jordaanoever met een vergunning naar Jerusalem mogen."
            }
        ],
    },
    {
        type: "Paragraph",
        text: "De Palestijnse christen Usama Nicola uit Bethlehem zegt dat ook hij en zijn geloofsgenoten een ‘emotionele connectie’ met Rachel voelen. ‘Wij zouden in staat willen zijn om te genieten van de heilige plaatsen in deze omgeving, in het bijzonder van het Graf van Rachel.’"
    },
    {
        type: "Paragraph",
        text: "Nicola werkt als projectcoördinator bij ‘Wi’am: The Palestinian Conflict Transformation Center’. Wi’am, zegt Nicola, investeert in zaken als conflictbemiddeling, vrouwenrechten, en traumaverwerking bij kinderen. Bij het ommuren van het Graf van Rachel raakte Wi’am een kwart van zijn land kwijt; in de eigenlijke tuin van het centrum, direct naast het monument, wonen nu joodse kolonisten. Enkele keren per jaar stroomt er vanuit de richting van het Graf van Rachel rioolwater onder de muur door, zo het overgebleven stuk tuin van Wi’am in."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}riool__mobile.jpg`,
            tablet: `${imageFolder}riool.jpg`,
            desktop: `${imageFolder}riool.jpg`,
            alt: "",
            text: "Via een tunneltje onder de afscheidingsmuur loopt er enkele keren per jaar rioolwater van het Graf van Rachel naar de tuin van Wi'am: The Palestinian Conflict Transformation Center. Foto: Usama Nicola"
        }
    },
    {
        type: "Paragraph",
        text: "De muur, zegt hij, is een ‘lelijk beeld dat de natuurlijke en door de mens gemaakte schoonheid van het land ontsiert’. Het grootste probleem is dat de muur de Palestijnen  toegang ontzegt tot Jeruzalem en de rest van ‘historisch Palestina’, zoals Nicola het hele land tussen de Jordaan-rivier en de Middellandse Zee noemt."
    },
    {
        type: "Paragraph",
        text: "Zo is het Graf van Rachel niet alleen meer het symbool van vruchtbaarheid, maar ook van de bezetting van de Westelijke Jordaanoever. Het bijbelse hartland is verworden tot het hart van de bezetting."
    },
]


// WEBPACK FOOTER //
// ./src/data/nl/stories/story3.js